import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { finanzcheck } from '@finanzcheck/teal-mui-theme';

import {
  ICeStageExclusiveBadgesFields,
  IExclusiveBadge,
} from 'types/generated/contentful';
import { HeroBannerExclusiveBadges } from './HeroBanner/HeroBannerExclusiveBadges';
import { BulletPointsExclusiveBadges } from './BulletPoints/BulletPointsExclusiveBadges';
import { ExclusivePartnerBadges } from './ExclusivePartners/ExclusivePartners';
import { Seals } from './Seals/Seals';
import { LoanSelector } from 'components/LoanSelector/LoanSelector';
import { LegalText } from './LegalText/LegalText';

const StageWrapper = styled(Container)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    padding: 0,
  },
}));

const StageFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

const MobileLoanSelector = styled('div')(({ theme }) => ({
  marginTop: '24px',
  display: 'block',
  width: '100%',
  // @ts-ignore:next-line
  backgroundColor: theme.palette.background.blue050,

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const MobileExclusivePartners = styled('div')(({ theme }) => ({
  display: 'block',
  width: '100%',
  marginTop: '24px',

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const getBulletPoints = (
  bulletPoints: string[] | undefined,
  headlineStyle: string,
) => {
  const color =
    headlineStyle === 'dark'
      ? finanzcheck.colors.text.blue
      : finanzcheck.colors.text.white;
  return (
    <BulletPointsExclusiveBadges
      bulletPoints={bulletPoints}
      textColor={color}
    />
  );
};

const getExclusivePartnerBadges = (
  exclusivePartners: IExclusiveBadge[] | undefined,
) => {
  return <ExclusivePartnerBadges exclusivePartners={exclusivePartners} />;
};

export type StageExclusiveBadgesProps = ICeStageExclusiveBadgesFields;
export const StageExclusiveBadges = (data: StageExclusiveBadgesProps) => {
  const {
    headline,
    subline,
    headlineColor,
    image,
    imageMobile,
    altText,
    bulletPoints,
    exclusiveBadges,
    seals,
  } = data;

  return (
    <StageWrapper maxWidth={false} disableGutters={true}>
      <HeroBannerExclusiveBadges
        image={image}
        imageMobile={imageMobile}
        altText={altText}
        headline={headline}
        subline={subline}
        headlineColor={headlineColor}
        bulletpoints={getBulletPoints(bulletPoints, headlineColor)}
        exclusivePartners={getExclusivePartnerBadges(exclusiveBadges)}
        loanSelector={<LoanSelector indexOnBestOffer="1" />}
      />
      <Container>
        <MobileLoanSelector>
          <LoanSelector indexOnBestOffer="1" />
        </MobileLoanSelector>
        <MobileExclusivePartners>
          {getExclusivePartnerBadges(exclusiveBadges)}
        </MobileExclusivePartners>

        <StageFooter>
          <Seals seals={seals} />
          <LegalText />
        </StageFooter>
      </Container>
    </StageWrapper>
  );
};
